import { del, get, post, put } from "./api_helper"
import { getAccessToken } from "./jwt-token-access/accessToken"

const API_BASE_URL = `${process.env.REACT_APP_API_INT_LEADS}/api`

// Listar todas as corretoras
export const getCorretoras = () => {
  return get(`${API_BASE_URL}/corretoras`, {
    headers: {
      Authorization: `Bearer ${getAccessToken()}`,
    },
  })
}

// Buscar corretora por ID
export const getCorretoraById = id => {
  return get(`${API_BASE_URL}/corretoras/${id}`, {
    headers: {
      Authorization: `Bearer ${getAccessToken()}`,
    },
  })
}

// Criar corretora
export const createCorretora = nome => {
  return post(
    `${API_BASE_URL}/corretoras`,
    { Nome: nome },
    {
      headers: {
        Authorization: `Bearer ${getAccessToken()}`,
      },
    }
  )
}

// Atualizar corretora
export const updateCorretora = (id, nome) => {
  return put(
    `${API_BASE_URL}/corretoras/${id}`,
    { Nome: nome },
    {
      headers: {
        Authorization: `Bearer ${getAccessToken()}`,
      },
    }
  )
}

// Excluir corretora (soft delete)
export const deleteCorretora = id => {
  return del(`${API_BASE_URL}/corretoras/${id}`, {
    headers: {
      Authorization: `Bearer ${getAccessToken()}`,
    },
  })
}

